import { render, staticRenderFns } from "./news-main.vue?vue&type=template&id=2c08d306&scoped=true&"
import script from "./news-main.vue?vue&type=script&lang=js&"
export * from "./news-main.vue?vue&type=script&lang=js&"
import style0 from "./news-main.vue?vue&type=style&index=0&id=2c08d306&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c08d306",
  null
  
)

export default component.exports